import Swiper, { Navigation } from "swiper";

document.addEventListener("DOMContentLoaded", function() {
  const stepsSwiper = new Swiper(".stepsSwiper", {
    rewind: true,
    slidesPerView: 1,
    spaceBetween: 20,
    pagination: {
      el: ".swiper-pagination",
      dynamicBullets: true,
    },
    modules: [Navigation],
    navigation: {
      nextEl: '[data-button-next]',
      prevEl: '[data-button-prev]'
    },
    breakpoints: {
      768: {
        slidesPerView: 1.5,
        spaceBetween: 20,
      },
    },
  });
});
